export const ENDPOINTS = {
  auth: {
    signIn:  '/v1/auth/signin',
    refresh: '/v1/auth/refresh',
    otp: {
      send:          '/v1/auth/otp/send',
      verify:        '/v1/auth/otp/verify',
      resetPassword: '/v1/auth/otp/reset-password',
    },
  },
  users: {
    list:          '/v1/identity/users',
    byId:          (id) => `/v1/identity/users/${id}`,
    me:            '/v1/identity/me',
    password:      '/v1/identity/me/password',
    activate:      (id) => `/v1/identity/users/${id}/activate`,
    deactivate:    (id) => `/v1/identity/users/${id}/deactivate`,
    resetPassword: (id) => `/v1/identity/users/${id}/reset-password`,
  },
  partners: {
    list:         '/v1/identity/partners',
    byUuid:       (uuid)        => `/v1/identity/partners/${uuid}`,
    activate:     (uuid)        => `/v1/identity/partners/${uuid}/activate`,
    deactivate:   (uuid)        => `/v1/identity/partners/${uuid}/deactivate`,
    token:        (uuid)        => `/v1/identity/partners/${uuid}/token`,
    licenses:     (uuid)        => `/v1/identity/partners/${uuid}/licenses`,
    licenseById:  (uuid, lUuid) => `/v1/identity/partners/${uuid}/licenses/${lUuid}`,
    licenseRenew: (uuid, lUuid) => `/v1/identity/partners/${uuid}/licenses/${lUuid}/renew`,
  },
  sites: {
    search:      '/v1/management/sites/search',
    byId:        (id) => `/v1/management/sites/${id}`,
    list:        '/v1/management/sites',
    users:          (id) => `/v1/management/permissions/sites/${id}/users`,
    effectiveUsers: (id) => `/v1/management/permissions/sites/${id}/effective-users`,
    assignUser:     '/v1/management/permissions/sites/assign',
    unassignUser:   '/v1/management/permissions/sites/unassign',
  },
  rooms: {
    list:        '/v1/management/rooms',
    byId:        (id) => `/v1/management/rooms/${id}`,
    users:       (id) => `/v1/management/permissions/rooms/${id}/users`,
    assignUser:  '/v1/management/permissions/rooms/assign',
    unassignUser:'/v1/management/permissions/rooms/unassign',
  },
  devices: {
    list:          '/v1/management/devices',
    byId:          (id) => `/v1/management/devices/${id}`,
    userMappings:          (id) => `/v1/management/permissions/devices/${id}/users`,
    effectiveUserMappings: (id) => `/v1/management/permissions/devices/${id}/users/effective`,
    assignUser:    '/v1/management/permissions/devices/assign',
    unassignUser:  '/v1/management/permissions/devices/unassign',
  },
  points: {
    search:           '/v1/management/points/search',
    unassignedSearch: '/v1/management/points/unassigned/search',
    byDevice:         (deviceId) => `/v1/management/points/device/${deviceId}`,
    assignDevice:     (pointId)  => `/v1/management/points/${encodeURIComponent(pointId)}/assign-device`,
    unassignDevice:   (pointId)  => `/v1/management/points/${encodeURIComponent(pointId)}/device`,
  },
  roomTypes: {
    search: '/v1/management/types/rooms/search',
    list:   '/v1/management/types/rooms',
    byId:   (id) => `/v1/management/types/rooms/${id}`,
  },
  deviceTypes: {
    search: '/v1/management/types/devices/search',
    list:   '/v1/management/types/devices',
    byId:   (id) => `/v1/management/types/devices/${id}`,
  },
  pointTypes: {
    search: '/v1/management/types/points/search',
    list:   '/v1/management/types/points',
    byId:   (id) => `/v1/management/types/points/${id}`,
  },
  projects: {
    list:              '/v1/management/projects',
    syncAll:           '/v1/management/projects/sync',
    syncPartner:       (partnerUuid) => `/v1/management/projects/${encodeURIComponent(partnerUuid)}/sync`,
    syncProjectPoints: (projId)      => `/v1/management/projects/${encodeURIComponent(projId)}/points/sync`,
  },
};
